import { Box, Text, Flex, Icon } from "@chakra-ui/react";
import { FaArrowUp, FaArrowDown, FaEquals } from "react-icons/fa";
import SystematicFactorsStackedAreaChart from "../../../components/charts/SystematicFactorsCharts/SystematicFactorsStackedAreaChart";
import SystematicFactorsLineChart from "../../../components/charts/SystematicFactorsCharts/SystematicFactorsLineChart";
import { useSelector } from "react-redux";
import BlurSection from "../../../shared/BlurSection/BlurSection";
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";
import React from "react";



const TrendIndicator = ({ direction }) => {
  switch (direction) {
    case "up":
      return <Icon as={FaArrowUp} color="green.500" />;
    case "down":
      return <Icon as={FaArrowDown} color="red.500" />;
    default:
      return <Icon as={FaEquals} color="gray.500" />;
  }
};

const ObservationText = ({ observation }) => {
  const { isAuthenticatedUser } = useSelector((state) => state.userReducer);

  if (observation?.percentage === 0 || observation === undefined) {
    return (
      <Text fontSize="sm" color="gray.500">
        No observation data available
      </Text>
    );
  }

  const getTrendDescription = () => {
    if (observation.direction === "up") {
      return observation.trend.includes("steady")
        ? "a strong increase"
        : "an increase";
    } else if (observation.direction === "down") {
      return observation.trend.includes("steady")
        ? "a strong decline"
        : "a decline";
    }
    return "stable performance";
  };

  return (
    <Flex
      align="center"
      gap={2}
      sx={{
        filter: !isAuthenticatedUser ? "blur(6px)" : "none",
        pointerEvents: !isAuthenticatedUser ? "none" : "auto",
      }}
    >
      <TrendIndicator direction={observation.direction} />
      <Text fontSize="sm">
        Observed {getTrendDescription()} in {observation.percentage}% of years
        {observation.percentage === 100
          ? " (all 7 years)"
          : ` (${observation.percentage} out of 7 years)`}
      </Text>
    </Flex>
  );
};

const Sales = ({ graphData, isAuthenticatedUser, observations }) => {
  const { modulesAccess: smeActivityModule } = useSelector(
    (state) => state.sectorWiseReducer
  );

  return (
    <>

    

{/* Total Sales Chart */}

<Box w="100%" mb={6} position="relative">
  
  <ObservationText observation={observations?.totalSales} />
  
  <ResponsiveContainer width="100%" height={230}>
    <AreaChart data={graphData.totalSales} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
      <defs>
        <linearGradient id="colorTotalSales" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#30D5C8" stopOpacity={0.4} />
          <stop offset="100%" stopColor="#30D5C8" stopOpacity={0.05} />
        </linearGradient>
      </defs>

      <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
      <XAxis dataKey="year" tick={{ fontSize: 12, fill: "#555" }} axisLine={{ stroke: "#ccc" }} />
      <YAxis tick={{ fontSize: 12, fill: "#555" }} axisLine={{ stroke: "#ccc" }} tickFormatter={(value) => `${(value / 10000000).toFixed(1)} Cr`} />
      <Tooltip formatter={(value) => [`${(value / 10000000).toFixed(2)} Cr`, "Value"]} labelFormatter={(label) => `Year: ${label}`} />
      <Area type="monotone" dataKey="value.income" stroke="#30D5C8" fill="url(#colorTotalSales)" strokeWidth={2} />
    </AreaChart>
  </ResponsiveContainer>
</Box>









      {/* Total EBITDA Chart */}
 <Box w="100%" position="relative">
  
  <Box
    position="absolute"
    top="2"
    right="2"
    zIndex="1"
    bg="whiteAlpha.800"
    px="2"
    borderRadius="md"
  >
    <ObservationText
      observation={observations?.totalEbitda}
      style={{
        filter: !isAuthenticatedUser ? "blur(3px)" : "none",
        pointerEvents: !isAuthenticatedUser ? "none" : "auto",
        display: "inline-block",
      }}
    />
  </Box>

  <SystematicFactorsStackedAreaChart
    data={graphData.totalEbitda}
    heading="Total EBITDA"
    dimension={{ width: "100%", height: "230px" }}
    areaFill="#30D5C8"
  />
</Box>


    </>
  );
};

export default Sales;

